import React from 'react'
import { ErrorIcon, StatusText, VoucherStatusContainer } from './VocuherSuccess.style'
import { useTranslation } from 'react-i18next'

const VoucherErrored = () => {
    const { t } = useTranslation()

    return (
        <VoucherStatusContainer>
            <ErrorIcon className="wemolo-cross-circle" />

            <StatusText>{t('carpay.voucher.invalid')}</StatusText>
        </VoucherStatusContainer>
    )
}

export default VoucherErrored
